import { render, staticRenderFns } from "./addon-upgrade-alert.vue?vue&type=template&id=3c831416&scoped=true&"
import script from "./addon-upgrade-alert.vue?vue&type=script&lang=js&"
export * from "./addon-upgrade-alert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c831416",
  null
  
)

export default component.exports